import { render, staticRenderFns } from "./ListAppraisals.vue?vue&type=template&id=33a0a1bd&"
import script from "./ListAppraisals.vue?vue&type=script&lang=js&"
export * from "./ListAppraisals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports